jQuery(document).ready(function ($) { 

  // change dropdown value on making property type selection
  $(".type-select a").click(function () {
    $(this).parents(".dropdown").find('.dropdown-toggle').text($(this).text());
    $(this).parents(".dropdown").find('.dropdown-toggle').val($(this).text());

    $(this).parent().siblings('input[type=hidden]').val($(this).data('value')); // update hidden input with selection
  });

  // Enable clicking on property table row
  $('.property-table').on('click', 'tr[data-url]:not(.has-properties)', function (e) {
    e.preventDefault();
    window.location = $(this).data('url');
  });
  $('.property-table').on('click', 'tr.has-properties', function (e) {
    e.preventDefault();
    $('tr[id=properties_for_scheme_' + $(this).data('scheme') + ']').toggle().find('.scheme-properties-container').slideToggle();
  });

  // sticky nav bar
  var stickyHomeNav = jQuery(".header");
  var hero = jQuery('header').height();
  jQuery(window).scroll(function() {
      if( jQuery(this).scrollTop() > hero + 5 ) {
          stickyHomeNav.addClass("sticky-nav-bar");
      } else {
          stickyHomeNav.removeClass("sticky-nav-bar");
      }
  });

  /**
   * Function to open a bootstrap modal based on ID
   * @param int
   */
  function directLinkModal(hash) {
    $(hash).modal('show');
  }
  // pop the modal if the hash matches
  directLinkModal(window.location.hash);

  var marker, map_style = [{ "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, { "elementType": "labels.text.fill", "stylers": [{ "color": "#616161" }] }, { "elementType": "labels.text.stroke", "stylers": [{ "color": "#f5f5f5" }] }, { "featureType": "administrative.land_parcel", "elementType": "labels.text.fill", "stylers": [{ "color": "#bdbdbd" }] }, { "featureType": "poi", "elementType": "geometry", "stylers": [{ "color": "#eeeeee" }] }, { "featureType": "poi", "elementType": "labels.text.fill", "stylers": [{ "color": "#757575" }] }, { "featureType": "poi.park", "elementType": "geometry", "stylers": [{ "color": "#e5e5e5" }] }, { "featureType": "poi.park", "elementType": "labels.text.fill", "stylers": [{ "color": "#9e9e9e" }] }, { "featureType": "road", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }] }, { "featureType": "road.arterial", "elementType": "labels.text.fill", "stylers": [{ "color": "#757575" }] }, { "featureType": "road.highway", "elementType": "geometry", "stylers": [{ "color": "#dadada" }] }, { "featureType": "road.highway", "elementType": "labels.text.fill", "stylers": [{ "color": "#616161" }] }, { "featureType": "road.local", "elementType": "labels.text.fill", "stylers": [{ "color": "#9e9e9e" }] }, { "featureType": "transit.line", "elementType": "geometry", "stylers": [{ "color": "#e5e5e5" }] }, { "featureType": "transit.line", "elementType": "geometry.fill", "stylers": [{ "color": "#e04e71" }] }, { "featureType": "transit.station", "elementType": "geometry", "stylers": [{ "color": "#eeeeee" }] }, { "featureType": "water", "elementType": "geometry", "stylers": [{ "color": "#c9c9c9" }] }, { "featureType": "water", "elementType": "labels.text.fill", "stylers": [{ "color": "#9e9e9e" }] }];

  if ($('#property-search__map').length) {

    var lat = parseFloat($('#property-search__map').data('lat')),
        lng = parseFloat($('#property-search__map').data('lng')),
        point = { lat: lat, lng: lng },
        bounds = new google.maps.LatLngBounds();

    var results_map = new google.maps.Map(document.getElementById('property-search__map'), {
        center: point,
        zoom: 15,
        gestureHandling: 'cooperative',
        styles: map_style
    });

    var markers = $('#property-search__map').data('markers'),
        infowindow = new google.maps.InfoWindow();

    // For each marker
    Object.keys(markers.results).map(function (key) {

        var data = markers.results[key];

        marker = new google.maps.Marker({
            position: { lat: parseFloat(data.lat), lng: parseFloat(data.lng) },
            map: results_map,
            title: data.name,
            icon: data.icon,
            anchor: { x: 15, y: 15 },
        });

        let addressHTML = 

        marker.addListener('click', function () {
            infowindow.setContent('<img width="175px" height="150px" alt="' + data.name + '" src=' + data.image + '><br><br><strong>' + data.name + '</strong><br>' + data.town + ', ' + data.postcode + '<br><a href="' + data.url + '"><br><span style="text-decoration: underline" >More information</span></a>');
            infowindow.open(results_map, this);
        });
        bounds.extend(marker.position);

    });

    // don't fit zoom to bounds on single properties
    if (Object.keys(markers.results).length > 1) {
        results_map.fitBounds(bounds);
    } else {
        results_map.setCenter(marker.position);
        results_map.setZoom(15);
    }

    google.maps.event.addListener(results_map, 'bounds_changed', function () {
        google.maps.event.trigger(results_map, 'resize');
    });
  };
});

// should use this...
async function initMap () {}
